// extracted by mini-css-extract-plugin
export var navigationItem = "styles-module--navigation-item--4a6c3";
export var navigationLink = "styles-module--navigation-link--dfe9d";
export var navigationLinkActive = "styles-module--navigation-link-active--47da8";
export var navigationWrapper = "styles-module--navigation-wrapper--d7fd1";
export var selectWrapper = "styles-module--select-wrapper--dc9de";
export var wrapper = "styles-module--wrapper--097fd";